














import Vue, { PropOptions } from 'vue';
import { Campaign, CampaignStatus } from '@/models';
import CampaignService from '@/services/CampaignService';
export default Vue.extend({
  props: {
    campaign: Object as PropOptions<Campaign>,
  },
  computed: {
    statusFormatted() {
      switch (this.campaign.status) {
        case CampaignStatus.Schedulled:
          if (CampaignService.isRunning(this.campaign)) {
            return 'Em andamento';
          } else {
            return 'Agendado';
          }
        case CampaignStatus.Sending:
          return 'Em andamento';
        case CampaignStatus.Draft:
          return 'Rascunho';
        case CampaignStatus.Paused:
          return 'Pausado';
        case CampaignStatus.Finished:
          return 'Terminado';
        case CampaignStatus.Cancelled:
          return 'Cancelado';
      }
      return '';
    },
    statusColor() {
      switch ((this.campaign as any).status) {
        case CampaignStatus.Schedulled:
          if (CampaignService.isRunning(this.campaign)) {
            return 'green';
          } else {
            return 'orange';
          }
        case CampaignStatus.Sending:
          return 'green';
        case CampaignStatus.Draft:
          return '#ddd';
        case CampaignStatus.Paused:
          return 'primary';
        case CampaignStatus.Finished:
          return '#ddd';
        case CampaignStatus.Cancelled:
          return 'red';
      }
      return '';
    },
  },
});
